import React, { useState , useEffect} from "react";
import "../../Assests/Globalcss/stylesheet.css";
import Navbar from "../../Componenets/Navbar";
import Footer from "../../Componenets/Footer";
import { useNavigate } from "react-router-dom";
import { useSelector , useDispatch } from "react-redux";
import { loadStripe } from "@stripe/stripe-js"; 
import {createPaymentIntent  ,resetOrder} from '../../Redux/Order/orderSlice'
import Loader from '../../Componenets/Loader'
import Swal from 'sweetalert2'
import {getCartItems_db} from '../../Redux/db_Cart/db_cartSlice'
import { imageUrl } from "../../Config";

const stripePromise = loadStripe("pk_test_51LBHZlD3bKBAJ7JYR7mdm55rp8g7UHvTPANhR2wih3CYqoAGit0GRwrDVBrGQ9yGh5IJsfWRgLaDYMaRZo3SckBr00JyR1Ydbt"); // Replace with your Stripe public key
const Index = () => {
  const navigate = useNavigate();
  const { cartItems, loading, error } = useSelector((state) => state.cart);
  const {paymentIntent , loading :paymentLoading ,error: paymentError} = useSelector((state)=>state.order)

  
  const dispatch = useDispatch()

  useEffect(()=>{
    dispatch(getCartItems_db())
  },[])

  const {dbCartItems} = useSelector((state)=> state.db_cart);

  const getSubTotal = () => {
    let total = 0;
    const items = login ? dbCartItems : cartItems;
    items.forEach((item) => {
      total += parseFloat(login ? item?.Product?.price : item?.price) * item.quantity;
    });
    return total.toFixed(2);
  };

  
  const getTotal = () => {
    return parseFloat(getSubTotal())+6.00
  };



  // if(paymentError){
  //   console.log(paymentError)
  //   Swal.fire({
  //     position: "top-end",
  //     icon: "error",
  //     title: "Failed: "+ paymentError.error,
  //     showConfirmButton: false,
  //     timer: 1500
  //   });
  //   dispatch(resetOrder())
  // }

  const [formData, setFormData] = useState({
    email: "",
    password : "",
    first_name: "",
    last_name: "",
    country: "",
    state: "",
    zip: "",
    address: "",
    appartment: "",
    phone: "",
    note: "",
  });

  const [errors, setErrors] = useState({});
  let login = localStorage.getItem('token');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" }); // Clear error when user types
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.first_name) newErrors.first_name = "First name is required";
    if (!formData.last_name) newErrors.last_name = "Last name is required";
    if (!formData.country) newErrors.country = "Country is required";
    if (!formData.state) newErrors.state = "State is required";
    if (!formData.zip) newErrors.zip = "ZIP code is required";
    if (!formData.phone) newErrors.phone = "Phone number is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if(!login){
      Swal.fire({
        icon: "warning",
        title: "Login in required",
        text: "Quickly login to checkout",
        showConfirmButton : true,
        showCancelButton : true,
        confirmButtonText : 'Go to Signin',
        denyButtonText : 'cancel'
      }).then((result)=>{
        if(result.isConfirmed){
          navigate('/signin')
        }
      });
      return
    }
    if (validateForm()) {
      console.log("Form Submitted:", formData);
      dispatch(createPaymentIntent({...formData , products : cartItems}))
      }
  };

  const initiateStripe = async (client_secret)=>{
    navigate("/paymentconfirmation" , {state : {clientSecret:client_secret}})
  }

  if(paymentIntent){
    initiateStripe(paymentIntent.clientSecret);
    dispatch(resetOrder())
  }
  
  const displayedCart = login ? dbCartItems : cartItems;

    

  return (
    <div>
      
      {paymentLoading && <Loader />}
      <section class="checkout-section">
        <div class="container">
          <div class="row">
            <div class="skiness-text">
              <span>Shop now </span>
              <h1>Glow Naturally - Shop Skincare That Loves You Back</h1>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- customer-section --> */}
      <section class="customer_section">
        <div class="container">
          <div class="row">
            <div class="col-lg-8">
              <div class="customer-text">
                <h5>Customer information</h5>
              </div>
              {/* <div class="already-text">
                <h5>
                  Already have an account? <span>Login</span>
                </h5>
              </div> */}
                <div className="user-inp mt-3">
                  <input
                    className="w-100"
                    type="email"
                    name="email"
                    placeholder="Email address*"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {errors.email && <span className="error">{errors.email}</span>}
                </div>
                {/* {!localStorage.getItem("token") && (
                   <div className="user-inp mt-3">
                   <input
                     className="w-100"
                     type="password"
                     name="password"
                     placeholder="Password*"
                     value={formData.password}
                     onChange={handleChange}
                   />
                   <h6 className="text-info">You are not logged in. we will use this email and password to create your account</h6>
                   {errors.password && <span className="error">{errors.password}</span>}
                 </div>
                )} */}
               
              <form>
                <div class="form-row d-flex mt-3 w-100">
                  <div class="form-group col-6">
                  <input
                    type="text"
                    className="form-control col-6"
                    name="first_name"
                    placeholder="First name*"
                    value={formData.first_name}
                    onChange={handleChange}
                  />
                  {errors.first_name && <span className="error">{errors.first_name}</span>}
                  </div>
                  <div class="form-group col-6  ps-1">
                  <input
                    type="text"
                    className="form-control col-6 ms-2"
                    name="last_name"
                    placeholder="Last name*"
                    value={formData.last_name}
                    onChange={handleChange}
                  />
                  {errors.last_name && <span className="error">{errors.last_name}</span>}
                  </div>
                </div>
               
                <div class="form-group mt-3">
                <input
                  type="text"
                  className="form-control mt-3"
                  name="country"
                  placeholder="Country*"
                  value={formData.country}
                  onChange={handleChange}
                />
                {errors.country && <span className="error">{errors.country}</span>}

                </div>
                <div class="form-row d-flex mt-3 padding-2">
                  <div class="form-group col-lg-6 col-md-6">
                  <input
                    type="text"
                    className="form-control col-lg-6"
                    name="address"
                    placeholder="House number or Street (Optional)"
                    value={formData.address}
                    onChange={handleChange}
                  />
                  </div>
                  <div class="form-group col-lg-6 col-md-6 ps-1">
                  <input
                    type="text"
                    className="form-control col-lg-6 ms-2"
                    name="appartment"
                    placeholder="Apartment, Suite (Optional)"
                    value={formData.appartment}
                    onChange={handleChange}
                  />
                  </div>
                </div>
                <div class="form-row d-flex mt-3">
                  <div class="form-group col-lg-4 col-md-4">
                  <input
                    type="text"
                    className="form-control col-lg-4"
                    name="city"
                    placeholder="City*"
                    value={formData.city}
                    onChange={handleChange}
                  />
                  {errors.city && <span className="error">{errors.city}</span>}
                  </div>
                  <div class="form-group col-lg-4 col-md-4 ps-1">
                  <input
                    type="text"
                    className="form-control col-lg-4"
                    name="state"
                    placeholder="State*"
                    value={formData.state}
                    onChange={handleChange}
                  />
                  {errors.state && <span className="error">{errors.state}</span>}

                  </div>
                  <div class="form-group col-lg-4 col-md-4 ps-1">
                  <input
                    type="text"
                    className="form-control col-lg-4 ms-2"
                    name="zip"
                    placeholder="Postcode/ZIP*"
                    value={formData.zip}
                    onChange={handleChange}
                  />
                  {errors.zip && <span className="error">{errors.zip}</span>}
                  </div>
                </div>

                <div class="form-group mt-3">
                <input
                  type="text"
                  className="form-control mt-3"
                  name="phone"
                  placeholder="Phone*"
                  value={formData.phone}
                  onChange={handleChange}
                />
                {errors.phone && <span className="error">{errors.phone}</span>}
                </div>
               
                <textarea
                  className="w-100 mt-3 text_areas"
                  name="note"
                  rows="4"
                  placeholder="Notes about your order (Optional)"
                  value={formData.note}
                  onChange={handleChange}
                ></textarea>
                <fieldset class="form-group field-text">
                  <h4>Payment</h4>
                 
                </fieldset>
                <div class="place-order">
                  <button onClick={(e)=>handleSubmit(e)}>Place Order</button>
                </div>
              </form>
            </div>
            <div class="col-lg-4 main-product">
              <div class="your-order">
                <h4>Your order</h4>
              </div>
              <div class="main-order-class">
                <div class="product_text">
                  <p>Product</p>
                  <p>Subtotal</p>
                </div>
              {displayedCart.length > 0 &&  displayedCart.map((item , index)=>{
                return(
                  <>
                <div class="nature-image-text">
                  <div class="milk-text-image">
                    <img src={!login ? imageUrl+item?.imageUrl: imageUrl+item?.Product?.imageUrl} alt="" />
                    <p>${!login ? item?.name : item?.Product?.price} X {item?.quantity}</p>
                  </div>
                  
                  <p>${parseFloat(!login? item?.price : item?.Product?.price) * item?.quantity}</p>
                </div>
                
                </>
                )
              })}
              <div class="product_text">
                  <p>Products</p>
                  <p>${getSubTotal()}</p>
                </div>
                <div class="product_text">
                  <p>Shipping</p>
                  <p>$6</p>
                </div>
                <div class="product_total">
                  <p>Total</p>
                  <p>${getTotal()}</p>
                </div>
              
                </div>

              
            </div>
          </div>
        </div>
      </section>
      <section class="email-section">
        <div class="container">
          <div class="newsletter-container">
            <span class="newsletter-text">Subscribe to our newsletter</span>
            <div class="inputs-btn d-flex">
              <input
                type="email"
                class="newsletter-input"
                placeholder="Your email address..."
              />
              <button class="newsletter-button">SUBSCRIBE</button>
            </div>
          </div>
        </div>
      </section>
        {/* <Check /> */}
        <Footer />

   
    </div>
  
  );
};

export default Index;
